import { render, staticRenderFns } from "./_ledgerDetails.vue?vue&type=template&id=32a5977b&scoped=true&"
import script from "./_ledgerDetails.vue?vue&type=script&lang=js&"
export * from "./_ledgerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a5977b",
  null
  
)

export default component.exports